<mat-icon class="info-tooltip-icon"
          *ngIf="message"
          [matTooltip]="message | info"
          matTooltipPosition="above">help_outline</mat-icon>
